import React from "react";
import OutletShopAllProducts from "./OutletShopAllProducts";
import OutletPopularCategoryCards from "./OutletPopularCategoryCards";
import { OutletPopularCategory } from "./OutletPopularCategory";
import OutletBranchAndLeafCategories from "./OutletBranchAndLeafCategories";
import { Facet } from "../Sidebar/Filters";
import OutletShopPopularProductsHeader from "./OutletShopPopularProductsHeader";
import OutletNewProductsCarousel from "./OutletNewProductsCarousel";
import { Product } from "~/common/Store/models/ProductListing";
interface Props {
  categoryFacets: Facet;
  popularCategories: OutletPopularCategory[];
  mostRecentOutletProducts: Product[];
}
const OutletShoppingFeatures = ({
  categoryFacets,
  popularCategories,
  mostRecentOutletProducts
}: Props) => {
  return <div className="bg-white py-4" data-sentry-component="OutletShoppingFeatures" data-sentry-source-file="OutletShoppingFeatures.tsx">
      <div className="container">
        {mostRecentOutletProducts?.length && <OutletNewProductsCarousel mostRecentOutletProducts={mostRecentOutletProducts} />}
        <OutletPopularCategoryCards popularCategories={popularCategories} data-sentry-element="OutletPopularCategoryCards" data-sentry-source-file="OutletShoppingFeatures.tsx" />
        <OutletShopAllProducts data-sentry-element="OutletShopAllProducts" data-sentry-source-file="OutletShoppingFeatures.tsx" />
        <OutletBranchAndLeafCategories categoryFacets={categoryFacets} data-sentry-element="OutletBranchAndLeafCategories" data-sentry-source-file="OutletShoppingFeatures.tsx" />
        <OutletShopPopularProductsHeader data-sentry-element="OutletShopPopularProductsHeader" data-sentry-source-file="OutletShoppingFeatures.tsx" />
      </div>
    </div>;
};
export default OutletShoppingFeatures;